var anchoventana=$(document).width();
var altoventana=$(window).height();
var md=767;
var medirScroll=true;
var medirDTM=false;


var caminoActivo="";

(function($) {
  var Sage = {
    'common': {
      init: function() {
        /**
         * declaracion variables globales
         */

        /**
          * init plugins y listeners comunes de proyectos
          */
         initPlugins();
         initListeners();

        /**
         * js del proyecto
         */
        setTimeout(function(){
          $("body").fadeIn();
        })


        var vuelta=1;
        var distancia=5;
        t=setInterval(function(){
          $(".deco-gente").css("background-position",(vuelta*distancia)*-1)
          vuelta+=1;
        },1000);

        /**
         * moviemiento "haz scroll"
         */
        function subeRaton(){
          TweenMax.to($(".cont-mouse"),0.5, {
            y:"-10",
            ease: Power4.easeOut,
            delay:1,
            onComplete:bajaRaton
          });          
        }
        function bajaRaton(){
            TweenMax.to($(".cont-mouse"),0.5, {
              y:"+0",
              ease: Bounce.easeOut,
              onComplete:subeRaton
            });            
        }
        subeRaton();


        $(".js-irTest").click(function(){

          $("#intro").fadeOut(function(){

            $([document.documentElement, document.body]).animate({
              scrollTop: 0
            }, 500);            

            $("#test").fadeIn(function(){

              $([document.documentElement, document.body]).animate({
                scrollTop: 0
              }, 500);

              swiperTest.update();
            });

          });
        });

        $(".js-respuestaPregunta").click(function(){
          
          // console.log(swiperTest.activeIndex);
          

          if (swiperTest.activeIndex<4){
            swiperTest.slideNext();
          }else{
            //De momento todos al viaje 1 
            //aquí habrá que calcular a qué camino hay que ir.

            setTimeout(function(){

              var puntos1=0;
              var puntos2=0;
              var puntos3=0;
              var puntos4=0;
  
              for (i=1;i<6;i++){
                
                if (parseInt($('input[name=respuesta'+i+']:checked').val(),10)==1){
                  puntos1++;
                }
  
                if (parseInt($('input[name=respuesta'+i+']:checked').val(),10)==2){
                  puntos2++;
                }
                
                if (parseInt($('input[name=respuesta'+i+']:checked').val(),10)==3){
                  puntos3++;
                }
                
                if (parseInt($('input[name=respuesta'+i+']:checked').val(),10)==4){
                  puntos4++;
                }              
  
              }
  
              // console.log("Resultados:");
              // console.log(puntos1);
              // console.log(puntos2);
              // console.log(puntos3);
              // console.log(puntos4);

              var maximo=0;

              if (puntos1>=maximo){
                maximo=puntos1;
              }

              if (puntos2>=maximo){
                maximo=puntos2;
              }
              
              if (puntos3>=maximo){
                maximo=puntos3;
              }
              
              if (puntos4>=maximo){
                maximo=puntos4;
              }              

              var camino="";

              // console.log("Maxim:"+maximo);

              if (puntos1>=maximo){
                camino=1;
              }
              if (puntos2>=maximo){
                camino=2;
              }
              if (puntos3>=maximo){
                camino=3;
              }
              if (puntos4>=maximo){
                camino=4;
              }   

              // console.log("camino:"+camino);
  
              $("#test").fadeOut(function(){

                caminoActivo=camino;
  
                $("#camino"+camino).fadeIn(function(){
  
                });
    
              });              

            },300);
 

          }

        });

        $(".js-empezarCamino").click(function(){
          
          var obj=$(this);

          obj.closest(".camino").find(".home").fadeOut(function(){

            obj.closest(".camino").find(".elcamino").fadeIn(function(){

              $([document.documentElement, document.body]).animate({
                scrollTop: 0
              }, 500);              
              colocaHitos();

            });
            colocaHitos();

          });

        });


        $(".js-irCamino").click(function(){
          
          var obj=$(this);

          $("#camino"+caminoActivo).fadeOut(function(){

            var ircamino=obj.attr("data-camino");

            $("#camino"+ircamino).closest(".camino").find(".home").show()
            $("#camino"+ircamino).closest(".camino").find(".elcamino").hide();

            caminoActivo=ircamino;

            $("#camino"+ircamino).fadeIn(function(){
              $([document.documentElement, document.body]).animate({
                scrollTop: 0
              }, 500);
            });

          });

        });


        var swiperTest = new Swiper('#swiper-test', {
          spaceBetween: 0,
          slidesPerView: 1,
          loop:false,
          freeMode:false,
          observer:true,
          allowTouchMove: false,
          pagination: {
            el: '.swiper-pagination-test',
            type: 'fraction',
          },
        });

        // Generate pagination bullets inside div with #bullets ID
            for (var i = 1; i < 6; i++){
              if ( i === 1){ 
                // add active class if it is the first bullet
                $('#bullets').append('<span class="swiper-pagination-bullet' + ' ' + 'swiper-pagination-bullet-active' + ' ' + 'slide' + i + '"></span>');
              } else {
                $('#bullets').append('<span class="swiper-pagination-bullet' + ' ' + 'slide' + i + '"></span>');
              }         
        }

        // ADD ACTIVE CLASS TO THE CURRENT BULLET
        // get all bullet elements
        var bullets = $('.swiper-pagination-bullet');
        swiperTest.on('slideChange', function () {
          console.log('holaaa', swiperTest.realIndex);
          if(swiperTest.realIndex>=1){
            $('.js-volver').css({"opacity": "1", "pointer-events": "auto", "filter": "none"})
          }
          if(swiperTest.realIndex<1){
            $('.js-volver').css({"opacity": ".4", "pointer-events": "none", "filter": "grayscale(100%)"})
          }
          // Get current slide from fraction pagination number
          var slide = "slide"+($('.swiper-pagination-current').html());
          // Remove active class from all bullets
          bullets.removeClass("swiper-pagination-bullet-active");
          // Check each bullet element if it has slideNumber class
          $.each(bullets, function (index, value) {
            if($(this).hasClass(slide)) {
              $(this).addClass("swiper-pagination-bullet-active");
              return false;
            }
          });
        });
        $('.js-volver').on('click', function (){
          swiperTest.slidePrev();
        });


        function colocaHitos(){

          //coloco los hitos de 
          var viajeActivo=$("section.camino:visible");
          var alturaScroll=jQuery("html").outerHeight()-$(window).height()-$("section.camino:visible .elcamino .finCamino").height();

          console.log("colocaHitos");

          $("section.camino:visible .elcamino .secCamino").each(function( index ) {

            var posScroll=$(this).offset().top-180;

            pctScroll=100-(100-posScroll*100/alturaScroll);

            //coloco el hito.
            $("section.camino:visible .elcamino .scrollbarCamino .hito:nth-child("+(index+2)+")").css("left",pctScroll+"%"); //porque los dos primeros hijos son el header y el scrollbar
            //console.log("section.camino:visible .elcamino .scrollbarCamino .hito:nth-child("+(index+2)+")");
            $("section.camino:visible .elcamino .scrollbarCamino .hito:nth-child("+(index+2)+")").attr("data-val",pctScroll);

            //console.log(index+":"+posScroll+":"+pctScroll);

          });


        }


        $( window ).resize(function() {
          colocaHitos();
        });


        $( window ).scroll(function() {

          //colocaHitos();

          var viajeActivo=$("section.camino:visible");

          // console.log(viajeActivo);

          var alturaScroll=jQuery("html").outerHeight()-$(window).height()-$(window).height()-$(window).height()+300;//este último es porque hay que restar también la última sección del camino que equivale al fin.
          var posScroll=$(window).scrollTop();
          //console.log(alturaScroll+" "+posScroll);

          //saco el pct.
          $pctScroll=(100-posScroll*100/alturaScroll);

          $(".js-barraprogreso").find(".barra").css("right",$pctScroll+"%");

          //activaciones de bullets.
          $(".js-hitoprogreso").each(function( index ) {

            // console.log(parseInt($(this).attr("data-val"),10));
            // console.log($pctScroll);

            if ( parseInt($(this).attr("data-val"),10) >= (100-$pctScroll) ){
              $(this).removeClass("activo");
            }else{
              $(this).addClass("activo");
            }

          });

        });        


      },
      finalize: function() {
      }
    },
  };
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.


function compartirFB(_url){
  var urlcompartir="https://www.facebook.com/sharer/sharer.php?u="+_url;
  window.open(urlcompartir, "Compartir", "width=640,height=480");
}

function compartirIN(_url){
  var urlcompartir="https://www.linkedin.com/shareArticle?mini=true&url="+_url+"&title=&summary=&source="
  window.open(urlcompartir, "Compartir", "width=640,height=480");
}

function compartirTW(_txt,_url){
  var texto=encodeURIComponent(_txt+" "+_url);
  var urlcompartir="https://twitter.com/intent/tweet?text="+texto;
  window.open(urlcompartir, "Compartir", "width=640,height=480");
}